import { Button } from "@/components/shared/buttons/Button";
import AddIcon from "@mui/icons-material/Add";
import { useDialogs } from "@toolpad/core";
import { NewPolicyTypeDialog } from "./dialogs/NewPolicyTypeDialog";

/**
 * Button to add a new policy type.
 */
export const AddPolicyTypeButton = () => {
    const dialogs = useDialogs();

    const handleClick = async () => {
        await dialogs.open(NewPolicyTypeDialog);
    };

    return (
        <Button
            type="button"
            variant="contained"
            color="secondary"
            disableElevation
            sx={{ borderRadius: 22 }}
            startIcon={<AddIcon />}
            onClick={handleClick}
        >
            Create
        </Button>
    );
};
